export default __webpack_public_path__ + "029470db0886823079c2eb606dc3833f.svg";